import { render, staticRenderFns } from "./CPDueDiligenceAccountHolderAddressDetails.vue?vue&type=template&id=2d3d23d7&scoped=true&"
import script from "./CPDueDiligenceAccountHolderAddressDetails.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceAccountHolderAddressDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d23d7",
  null
  
)

export default component.exports